import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { getData } from "../../../../../../services/library";

// Etiqueta chica arriba y valor abajo; los vacíos se muestran como "—".
const StyledBox = ({ label, value }) => (
  <Box>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        display: "block",
        textTransform: "uppercase",
        fontWeight: 600,
        letterSpacing: 0.4,
        fontSize: "0.65rem",
        lineHeight: 1.2,
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        fontSize: "0.8rem",
        lineHeight: 1.3,
        wordBreak: "break-word",
        color: value ? "text.primary" : "text.disabled",
      }}
    >
      {value || "—"}
    </Typography>
  </Box>
);

const Panel = ({ titulo, children }) => (
  <Box
    sx={{
      border: "1px solid #ccc",
      borderRadius: "5px",
      padding: "4px 8px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      backgroundColor: "#f9f9f9",
      height: "100%",
    }}
  >
    <Typography
      variant="caption"
      fontWeight="700"
      color="primary"
      sx={{ display: "block", lineHeight: 1.3, mb: 0.25 }}
    >
      {titulo}
    </Typography>
    <Grid container rowSpacing={0.25} columnSpacing={1}>
      {children}
    </Grid>
  </Box>
);

const unir = (valores, separador) => valores.filter(Boolean).join(separador);

// Detalle del pedido en dos columnas: datos del cliente a la izquierda y de
// la dirección de entrega seleccionada a la derecha. "direccion" es la fila
// de buscarDireccionesSucAuth (trae también los datos del cliente).
export default function DetalleClienteDireccion({ direccion }) {
  const [ultCompra, setUltCompra] = useState([]);
  const idDireccion = direccion?.id;

  // Se recarga al cambiar de dirección.
  useEffect(() => {
    setUltCompra([]);
    if (idDireccion) {
      getData("/envasado_pedidos/ultimacompra/" + idDireccion, setUltCompra);
    }
  }, [idDireccion]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <Panel titulo="Cliente">
          <Grid item xs={4}>
            <StyledBox label="CUIT/DNI" value={direccion?.cuit} />
          </Grid>
          <Grid item xs={4}>
            <StyledBox label="Condición IVA" value={direccion?.cond_iva} />
          </Grid>
          <Grid item xs={4}>
            <StyledBox
              label="Teléfonos"
              value={unir(
                [
                  direccion?.cliente_telefono_1,
                  direccion?.cliente_telefono_2,
                  direccion?.cliente_telefono_3,
                ],
                " / ",
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <StyledBox label="Mails" value={direccion?.mails_cliente} />
          </Grid>
          <Grid item xs={6}>
            <StyledBox label="Observaciones" value={direccion?.obs_cliente} />
          </Grid>
        </Panel>
      </Grid>

      <Grid item xs={12} md={6}>
        <Panel titulo="Dirección de entrega">
          <Grid item xs={5}>
            <StyledBox
              label="Dirección"
              value={unir([direccion?.nombre_direccion, direccion?.direccion_entrega], " - ")}
            />
          </Grid>
          <Grid item xs={4}>
            <StyledBox
              label="Localidad"
              value={unir([direccion?.localidad, direccion?.provincia], ", ")}
            />
          </Grid>
          <Grid item xs={3}>
            <StyledBox label="Contacto" value={direccion?.contacto} />
          </Grid>
          <Grid item xs={4}>
            <StyledBox
              label="Teléfonos"
              value={unir(
                [direccion?.telefono_1, direccion?.telefono_2, direccion?.telefono_3],
                " / ",
              )}
            />
          </Grid>
          <Grid item xs={4}>
            <StyledBox label="Mails" value={direccion?.mails} />
          </Grid>
          <Grid item xs={4}>
            <StyledBox label="Observaciones" value={direccion?.observaciones} />
          </Grid>
          {ultCompra.length > 0 ? (
            <Grid item xs={12}>
              <StyledBox
                label="Última compra"
                value={unir([ultCompra[0].fecha_format, ultCompra[0].productos], " · ")}
              />
            </Grid>
          ) : null}
        </Panel>
      </Grid>
    </Grid>
  );
}
